module.exports = __webpack_public_path__ + "img/cave158.a6683f02.jpg";